import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {EndYearEvaluation} from 'src/app/free-evaluation-end-year/_interfaces/end-year-evaluation.interface';
import {FreeEvaluationEndYearRule} from '../../interfaces/end-year-evaluation-rule.interface';
import {ProcessStatusEnum} from '../../interfaces/process.interface';
import {ProcessConfig} from '../../interfaces/process-config.interface';
import {environment} from '../../../../environments/environment';

@Component({
    selector: 'app-concepts-table',
    templateUrl: './concepts-table.component.html',
    styleUrls: ['./concepts-table.component.scss'],
})
export class ConceptsTableComponent implements OnInit, OnChanges {
    @Output() confirmSendEvaluations = new EventEmitter<Array<EndYearEvaluation>>();
    @Input() evaluations: Array<EndYearEvaluation>;
    @Input() endYearEvalRule: FreeEvaluationEndYearRule;
    @Input() status: ProcessStatusEnum;
    @Input() processConfig: ProcessConfig;
    @Input() processWillOpen: boolean = false;
    @Input() processIsClosed: boolean = false;
    @Input() varIsAvailable: boolean = false;
    @Input() dynamicLimitConcepts: boolean = false;

    public lastLimitColor: string = '';
    public penultimateLimitColor: string = '';
    public remainingLimitColor: string = '';

    constructor() {
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        this.updateLimits();
    }

    updateLimits() {
        let isInsideLastLimit = this.endYearEvalRule.lastSelecteds <= this.endYearEvalRule.maxLast;
        let isInsidePenultimateLimit =
            isInsideLastLimit ?
                (this.endYearEvalRule.penultimateSelecteds + this.endYearEvalRule.lastSelecteds) <= this.endYearEvalRule.maxPenultimate
                : this.endYearEvalRule.penultimateSelecteds <= this.endYearEvalRule.maxPenultimate;
        let isInsideRemainingLimit = this.endYearEvalRule.remainingSelecteds <= this.endYearEvalRule.maxRemaining;

        this.lastLimitColor = isInsideLastLimit ? 'success' : 'danger';
        this.penultimateLimitColor = isInsidePenultimateLimit ? 'success' : 'danger';
        this.remainingLimitColor = isInsideRemainingLimit ? 'success' : 'danger';
    }

    confirmSendEvaluation(evaluations: Array<EndYearEvaluation>) {
        this.confirmSendEvaluations.emit(evaluations);
    }
}
